import _ from 'underscore';
import Backbone from 'backbone';
import EventBus from '../../utils/eventbus';
import SocketEvents from '../../events/socket';
import ItemModel from './model';

export default Backbone.Collection.extend({
	model: ItemModel,

	url: function() {
		return document.URL;
	},

	comparator: function(model) {
		return model.get('MinutesLeft');
	},

	initialize: function(models, options) {
		// Event listeners
		this.listenTo(EventBus, SocketEvents.NOTIFICATION, this.onNotification);
	},

	// Private
	// Trigger 'remove' event on the previous models, so that connected views can be removed
	onReset: function(collection, options) {
		_.each(options.previousModels, function(model) {
			model.trigger('remove');
		});
	},

	// notification received, add to collection
	onNotification: function(data) {
		this.add(data, {parse: true});
	}
});
